var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconProfileSecurity1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.08333H14.6667C14.8877 6.08333 15.0996 6.17113 15.2559 6.32741C15.4122 6.48369 15.5 6.69565 15.5 6.91667V16.9167C15.5 17.1377 15.4122 17.3496 15.2559 17.5059C15.0996 17.6622 14.8877 17.75 14.6667 17.75H1.33333C1.11232 17.75 0.900358 17.6622 0.744078 17.5059C0.587797 17.3496 0.5 17.1377 0.5 16.9167V6.91667C0.5 6.69565 0.587797 6.48369 0.744078 6.32741C0.900358 6.17113 1.11232 6.08333 1.33333 6.08333H3V5.25C3 3.92392 3.52678 2.65215 4.46447 1.71447C5.40215 0.776784 6.67392 0.25 8 0.25C9.32608 0.25 10.5979 0.776784 11.5355 1.71447C12.4732 2.65215 13 3.92392 13 5.25V6.08333ZM2.16667 7.75V16.0833H13.8333V7.75H2.16667ZM7.16667 11.0833H8.83333V12.75H7.16667V11.0833ZM3.83333 11.0833H5.5V12.75H3.83333V11.0833ZM10.5 11.0833H12.1667V12.75H10.5V11.0833ZM11.3333 6.08333V5.25C11.3333 4.36594 10.9821 3.5181 10.357 2.89298C9.7319 2.26786 8.88406 1.91667 8 1.91667C7.11594 1.91667 6.2681 2.26786 5.64298 2.89298C5.01786 3.5181 4.66667 4.36594 4.66667 5.25V6.08333H11.3333Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconProfileSecurity1);
export default __webpack_public_path__ + "static/media/TH-Icon-Profile-Security-1.cb7807538534cfdf46770e7b9b06ba99.svg";
export { ForwardRef as ReactComponent };